import { styled } from '@mui/material/styles';

import { Theme, rem } from '../../theme';

export const StyledAppTile = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        max-width: ${theme.tggSpacing(rem(102.4), 256)};
        padding-bottom: ${theme.tggSpacing(rem(3), 7.5)};
        margin: auto;
        border: ${theme.tggSpacing(rem(0.2), 1)}
            solid ${theme.palette.common.lightGrey};
        border-radius: ${theme.tggSpacing(rem(0.8), 3)};
	`}
`;

export const StyledContainer = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        /* stylelint-disable unit-allowed-list */   
        padding: ${theme.tggSpacing([rem(3), rem(3), 0, rem(3)], [7.5, 7.5, 0, 7.5])};
    margin-bottom: ${theme.tggSpacing(rem(1), 2.5)};
    text-align: left;

    ${theme.breakpoints.up('mobile')} {
        padding: ${theme.tggSpacing([rem(3), rem(6), 0, rem(3)], [7.5, 15, 0, 7.5])};
        text-align: center;
    }
	`}
`;

export const SecondaryTitle = styled('div')`
    margin-top: ${({ theme }: { theme: Theme }) =>
        theme.tggSpacing(rem(0.5), 1.25)};
`;

export const StyledImageContainer = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        display: flex;
        min-height: ${theme.tggSpacing(rem(15), 37.5)};
        max-height: ${theme.tggSpacing(rem(35.8), 89.5)};
        img {
            border-top-left-radius: ${theme.tggSpacing(rem(0.8), 3)};
            border-top-right-radius: ${theme.tggSpacing(rem(0.8), 3)};
        }
	`}
`;

export const StyledCheckList = styled('ul')`
    ${({ theme }: { theme: Theme }) => `
        padding: ${theme.tggSpacing(0, 0)};
        margin: ${theme.tggSpacing([rem(2), 0, rem(2)], [5, 0, 5])};
        font-weight: normal;
        text-align: left;

        li {
            display: flex;
            margin-bottom: ${theme.tggSpacing(rem(1), 2.5)};
            list-style: none;

            svg {
                margin-top: ${theme.tggSpacing(rem(0.2), 1)};
                margin-right: ${theme.tggSpacing(rem(1.1), 2.75)};
            }
        }

        ${theme.breakpoints.up('mobile')} {
            display: inline-block;
            column-count: 2;
            column-gap: ${theme.tggSpacing(rem(4), 10)};
            margin: ${theme.tggSpacing([rem(3), 0, rem(2)], [7.5, 0, 5])};
        }
	`}
`;

export const LinksContainer = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        display: flex;
        gap: ${theme.tggSpacing(rem(1), 2.5)};
        justify-content: center;
        padding-top: ${theme.tggSpacing(rem(1), 2.5)};

        a {
            display: contents;
        }

        ${theme.breakpoints.up('mobile')} {
            gap: ${theme.tggSpacing(rem(2), 5)};
            padding-top: ${theme.tggSpacing(0, 0)};
        }
	`}
`;
